<template>
	<div class="job-card" v-if="job" :class="{showing:display}">
		<div class="base-information">
			<div><a :href="'/requisitions/view/' + requisition.id">{{ job.name }} - {{ requisition.name }}</a></div>
		</div>
		<div class="uk-clearfix"></div>
		<div class="divider thin uk-margin-small"></div>
		<div class="uk-grid">
            <div class="uk-width-1-2">
                <strong>Start</strong>
                <div>{{ fDate(job.start_date) }}</div>
            </div>
            <div class="uk-width-1-2">
                <strong>End</strong>
                <div>{{ fDate(job.end_date) }}</div>
            </div>
            <div class="uk-width-1-2">
                <strong>Amount Placed</strong>
                <div>{{ job.placements.length }}</div>
            </div>
            <div class="uk-width-1-2">
                <strong>Amount needed</strong>
                <div>{{ job.quantity }}</div>
            </div>
            <div class="uk-width-1-2">
                <strong>Craft Code</strong>
                <div>{{ job.quantity }}</div>
            </div>
            <div class="uk-width-1-2">
                <strong>Travel In</strong>
                <div>{{ job.travel_in }}</div>
            </div>
            <div class="uk-width-1-2">
                <strong>Travel Out</strong>
                <div>{{ job.travel_out }}</div>
            </div>
            <div class="uk-width-1-2">
                <strong>Sub Rate</strong>
                <div>{{ job.sub_rate }}</div>
            </div>
            <div class="uk-width-1-2">
                <strong>Sub Rule</strong>
                <div>{{ job.per_diem_type }}</div>
            </div>
		</div>
		<i class="fas fa-times closer" @click="hide"></i>
	</div>
</template>

<script>
    import Format from "../Classes/Format";
	export default {
		name: "JobCard",

		components: {},

		props:{
			displayHours:{type:Boolean, default:false}
		},

		data() {
			return {
				job: null,
				requisition: null,
				display: false,
				lastX:0,
				lastY:0,
			};
		},

		mounted() {
			document.addEventListener("mousemove", (ev) => this.follow(ev));
			this.placeBox(-500,-500);
		},

		methods: {
			show(job, req) {
				if (job, req) {
					this.display = true;
					this.job = job;
                    this.requisition = req;
				}
				setTimeout(() => this.placeBox(this.lastX, this.lastY), 0);
			},

			hide() {
				this.display = false;
				setTimeout(() => this.placeBox(-500, -500), 340);
			},
			follow(event) {
				this.lastX = event.clientX;
				this.lastY = event.clientY;
			},
            fDate(dt){
                return Format.formatDate(dt);
            },
            sDate(dt){
                return Format.shortDate(dt);
            },
			placeBox(mouseX, mouseY){
				if (this.$el && this.$el.style) {
					if (mouseY > (window.innerHeight * .75)) {
						this.$el.style.top = "";
						this.$el.style.bottom = (window.innerHeight - mouseY) + "px";
					} else {
						this.$el.style.top = (mouseY - 120) + "px";
						this.$el.style.bottom = "";
					}

					if (mouseX > (window.innerWidth * .55)) {
						this.$el.style.left = "";
						this.$el.style.right = (window.innerWidth - mouseX + 50) + "px";
					} else {
						this.$el.style.left = (mouseX + 50) + "px";
						this.$el.style.right = "";
					}
				}
			}
		}
	}
</script>
